import { render } from "./ImprimirContado.vue?vue&type=template&id=b52480d4&scoped=true"
import script from "./ImprimirContado.vue?vue&type=script&lang=js"
export * from "./ImprimirContado.vue?vue&type=script&lang=js"

import "./ImprimirContado.vue?vue&type=style&index=0&id=b52480d4&scoped=true&lang=css"

import exportComponent from "/woodpecker/src/github.com/Multpex/multpex.front.gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b52480d4"]])

export default __exports__
import QPage from 'quasar/src/components/page/QPage.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QPage});
